__webpack_require__.p = "/my-future-wealth/_next/";